// extracted by mini-css-extract-plugin
export var wrapper = "PostalCode-module--wrapper--JuZqE";
export var content = "PostalCode-module--content--rxLQQ";
export var form = "PostalCode-module--form--DiEeY";
export var headline = "PostalCode-module--headline--D4X2d";